import { render, staticRenderFns } from "./MultiqContentIdChip.vue?vue&type=template&id=418d1b44&scoped=true&"
import script from "./MultiqContentIdChip.vue?vue&type=script&lang=ts&"
export * from "./MultiqContentIdChip.vue?vue&type=script&lang=ts&"
import style0 from "./MultiqContentIdChip.vue?vue&type=style&index=0&id=418d1b44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418d1b44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
